import { ICoreContext, getUrlSync } from '@msdyn365-commerce/core';
import React from 'react';

export const buildFaqStatusPageUrl = (context: ICoreContext): string => {
    return getUrlSync('faq#Status', context.actionContext) || '';
};

const buildHtmlWithFaqLink = (text: string, resources: any, context: ICoreContext): string => {
    const faqUrl = buildFaqStatusPageUrl(context);
    return text.replace(
        '{FAQ_PAGE}',
        `<a title="${resources.statusLinkTitle}" aria-label="${resources.statusLinkTitle}" href="${faqUrl}">${resources.statusLinkPlaceholder}</a>`
    );
};

const renderHtml = (html: string) => <div dangerouslySetInnerHTML={{ __html: html }} />;

export const formatStatusCodeForTooltip = (resources: any, context: ICoreContext) => {
    const html = buildHtmlWithFaqLink(resources.globalStatusInformationDescription, resources, context);

    return (
        <div onClick={e => e.stopPropagation()}>
            <div>{renderHtml(html)}</div>
        </div>
    );
};

export const formatOverallStatusCodeForTooltip = (resources: any, context: ICoreContext) => {
    const html = buildHtmlWithFaqLink(resources.globalOverallStatusInformationDescription, resources, context);

    return (
        <div onClick={e => e.stopPropagation()}>
            <div>
                <p>{renderHtml(html)}</p>
            </div>
        </div>
    );
};
